import { render, staticRenderFns } from "./QuickAccessDataTable.vue?vue&type=template&id=47e2d6e2&"
import script from "./QuickAccessDataTable.vue?vue&type=script&lang=ts&"
export * from "./QuickAccessDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VContent})
